/* ═══════════════════════════════════════════════════
   recently-viewed.js
   Homepage — Continue Browsing For
   jQuery: $.ajax Get API + Swiper category card render
   ═══════════════════════════════════════════════════ */

$(document).ready(function () {

  var $section = $('[data-rv-section]');
  if (!$section.length) return;

  var SID         = $section.data('rv-section');
  var customerRaw = $section.data('rv-customer');
  var customerId  = (!customerRaw || customerRaw === '' || customerRaw === 'null')
                      ? null
                      : String(customerRaw);
  var DETAIL_URL  = $section.data('rv-detail-page');
  var fingerprint = localStorage.getItem('browserID') || null;

  if (!fingerprint) { showEmpty(); return; }

  showLoading();

  /* ── Call Get API ────────────────────────────── */
  $.ajax({
    type        : 'POST',
    url         : 'https://ddbadmin.duckduckbaby.in/api/v3/get-recently-viewed-product',
    contentType : 'application/json',
    dataType    : 'json',
    data        : JSON.stringify({
      device_fingerprint  : fingerprint,
      shopify_customer_id : customerId
    }),
    success: function (json) {
      hideLoading();
      var cats = (json && json.status && $.isArray(json.data)) ? json.data : [];
      if (cats.length === 0) { showEmpty(); return; }
      renderSlides(cats);
    },
    error: function () {
      hideLoading();
      showEmpty();
    }
  });

  /* ── Build Swiper slides (one per category) ──── */
  function renderSlides(categories) {
    var html = '';

    $.each(categories, function (i, cat) {
      /* Build detail page URL with category context */
      var qs   = $.param({ category_id: cat.id, category_title: cat.title });
      var href = DETAIL_URL + '?' + qs;

      html += '<div class="swiper-slide">'
            +   '<a class="rv-api-card" href="' + esc(href) + '">'
            +     '<div class="rv-api-card__img-wrap">'
            +       '<img src="'  + esc(cat.image) + '"'
            +            ' alt="' + esc(cat.title) + '"'
            +            ' loading="lazy">'
            +     '</div>'
            +     '<div class="rv-api-card__info">'
            +       '<p class="rv-api-card__title">' + esc(cat.title) + '</p>'
            +     '</div>'
            +   '</a>'
            + '</div>';
    });

    $('#rv-swiper-wrapper-' + SID).html(html);
    $('#rv-section-' + SID).show();
    var $parentSection = $section.closest('.shopify-section').length ? $section.closest('.shopify-section') : $section.parent();
    $parentSection.removeClass('rv-api-section--empty hide-section-desktop hide-section-mobile');
    $parentSection.find('[class*="section-spacer"]').show();

    /* Init Swiper */
    new Swiper('.rv-api-swiper-' + SID, {
      slidesPerView : 2.3,
      spaceBetween  : 15,
      grabCursor    : true,
      navigation    : {
        prevEl : '.rv-swiper-prev-' + SID,
        nextEl : '.rv-swiper-next-' + SID
      },
      breakpoints   : {
        750: {
          slidesPerView : 4,
          spaceBetween  : 72
        }
      }
    });
  }

  /* ── Visibility helpers ─────────────────────── */
  function showLoading() { $('#rv-loading-' + SID).show(); }
  function hideLoading() { $('#rv-loading-' + SID).hide(); }
  function showEmpty() { 
    $('#rv-empty-'   + SID).hide(); 
    $('#rv-loading-' + SID).hide(); 
    $('#rv-section-' + SID).hide(); 
    var $parentSection = $section.closest('.shopify-section').length ? $section.closest('.shopify-section') : $section.parent();
    $parentSection.addClass('rv-api-section--empty hide-section-desktop hide-section-mobile');
    $parentSection.find('[class*="section-spacer"]').hide();
  }

  /* ── Safe HTML escape via jQuery ────────────── */
  function esc(s) {
    return $('<div>').text(String(s || '')).html();
  }

  /* ── Fix Swatch Popup Z-Index, Position, and Body Scroll Lock across devices ── */
  function fixSwatchPopupZIndex() {
    function lockBodyScroll() {
      if (!document.body.classList.contains('rvd-body-scroll-lock')) {
        const scrollY = window.scrollY || window.pageYOffset;
        document.documentElement.style.setProperty('--rvd-scroll-y', `${scrollY}px`);
        document.documentElement.classList.add('rvd-body-scroll-lock');
        document.body.classList.add('rvd-body-scroll-lock');
        document.body._rvdScrollY = scrollY;
      }
    }

    function unlockBodyScroll() {
      if (document.body.classList.contains('rvd-body-scroll-lock')) {
        const scrollY = document.body._rvdScrollY || 0;
        document.documentElement.classList.remove('rvd-body-scroll-lock');
        document.body.classList.remove('rvd-body-scroll-lock');
        if (typeof scrollY === 'number' && scrollY > 0) {
          window.scrollTo(0, scrollY);
        }
      }
    }

    // Prevent touch dragging on overlay on iOS Safari
    document.addEventListener('touchmove', function(e) {
      if (e.target.closest('.wizzy-swatch-bg-overlay')) {
        e.preventDefault();
      }
    }, { passive: false });

    // Also listen for ESC key to unlock scroll
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') unlockBodyScroll();
    });

    document.addEventListener('click', function(e) {
      const swatch = e.target.closest('.wizzy-swatch-option');
      if (!swatch) return;

      const bgoverlay = document.querySelector('.wizzy-swatch-bg-overlay');
      if (bgoverlay) {
        bgoverlay.classList.add('rvd-overlay-waiting');
      }

      document.querySelectorAll('body > .wizzy-swatch-content').forEach(old => {
        if (old._originalSibling) {
          old._originalSibling.after(old);
        }
      });

      const popup = swatch.nextElementSibling;
      if (!popup) return;
      const content = popup.nextElementSibling;
      if (!content || !content.classList.contains('wizzy-swatch-content')) return;

      content._originalSibling = popup;

      const checkOpen = setInterval(function() {
        if (content.style.display === 'block' || content.innerHTML.trim() !== '') {
          clearInterval(checkOpen);
          if (content.parentNode !== document.body) {
            document.body.appendChild(content);
          }
          if (bgoverlay) {
            bgoverlay.classList.remove('rvd-overlay-waiting');
          }
          lockBodyScroll();
        }
      }, 50);

      setTimeout(() => {
        clearInterval(checkOpen);
        if (bgoverlay) bgoverlay.classList.remove('rvd-overlay-waiting');
      }, 5000);
    }, true);

    document.addEventListener('click', function(e) {
      if (e.target.closest('.wizzy-swatch-bg-overlay, .swatch-close-icon')) {
        const bgoverlay = document.querySelector('.wizzy-swatch-bg-overlay');
        if (bgoverlay) bgoverlay.classList.remove('rvd-overlay-waiting');
        unlockBodyScroll();
        setTimeout(function() {
          document.querySelectorAll('body > .wizzy-swatch-content').forEach(content => {
            if (content._originalSibling) {
              content._originalSibling.after(content);
            }
          });
        }, 100);
      }
    }, true);
  }

  fixSwatchPopupZIndex();

});
